import standalones from '../../contracts/standalones'
import getConfig from 'next/config'
import { IncomingMessage } from 'http'

const {
  publicRuntimeConfig: { domain },
} = getConfig()

export function getStandaloneName(req: IncomingMessage = null) {
  const hostname = req ? req.headers.host : location.hostname
  if (!hostname) return null

  const name = hostname.split('.')[0]

  if (Object.keys(standalones).includes(name)) return name

  return null
}

export function redirectStandaloneSubdomain(
  itemId = null,
  res = null,
  asPath = null
) {
  if (res) {
    // リダイレクト対象のアイテムIDだった場合、対象のアーティストアカウントIDを返す
    const artistAccountId = Object.keys(standalones).find(artistAccountId => {
      if (
        standalones[artistAccountId].redirectStandaloneItemId.includes(itemId)
      )
        return artistAccountId
    })

    // 対象アーティストのスタンドアロンWebへ遷移
    if (artistAccountId) {
      const standaloneDomain = domain.replace(
        /:\/\/(www.)?/,
        `://${artistAccountId}.`
      )
      res.writeHead(302, {
        Location: [standaloneDomain, asPath].join(''),
      })
      res.end()
      return
    }

    return
  }

  return
}
